import React from 'react';
import { Badge } from '@shadcn/components/ui/badge';
import { EXECUTION_STATUS_COLORS, EXECUTION_STATUS_LABELS } from '../../constants';

const StatusBadge = ({ status }) => {
  const config = EXECUTION_STATUS_COLORS[status] || EXECUTION_STATUS_COLORS.pending;
  const label = EXECUTION_STATUS_LABELS[status] || status;

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${config.className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
